export default "__VITE_ASSET__D7ln7oWZ__"